module.exports = __webpack_public_path__ + "img/encore-logo-tv.d1d17e0.png";